var map = {
	"../pages/checklist-comparativo/checklist-comparativo.module": [
		857,
		9
	],
	"../pages/checklist/checklist.module": [
		859,
		11
	],
	"../pages/concorrencia/concorrencia.module": [
		872,
		0
	],
	"../pages/concorrencias/concorrencias.module": [
		858,
		10
	],
	"../pages/geral-vendas/geral-vendas.module": [
		869,
		8
	],
	"../pages/home/home.module": [
		866,
		2
	],
	"../pages/login/login.module": [
		860,
		15
	],
	"../pages/modal-shopping-preco/modal-shopping-preco.module": [
		861,
		14
	],
	"../pages/novos-kits/novos-kits.module": [
		867,
		7
	],
	"../pages/novos-negocios/novos-negocios.module": [
		870,
		6
	],
	"../pages/perfil/perfil.module": [
		862,
		13
	],
	"../pages/pop-over/pop-over.module": [
		863,
		12
	],
	"../pages/relacao/relacao.module": [
		864,
		5
	],
	"../pages/relatorio-anuncios-vinculados-perdendo/relatorio-anuncios-vinculados-perdendo.module": [
		871,
		4
	],
	"../pages/shopping-precos/shopping-precos.module": [
		868,
		3
	],
	"../pages/uso/uso.module": [
		865,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 233;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 233
// module chunks = 16